import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "../../graphic/Icon";
import styles from "./CourseCard.scss";

/**
 * Tall (9:16) course card: cover image with the title on top of it. The whole card is the link.
 * @param link – where the card leads
 * @param linkState – router state passed along with the link
 * @param image – cover image url; without it the cover is a striped pattern with a course icon
 * @param meta – small line below the title, e.g. the number of questions
 * @param badge – small label in the top-left corner, e.g. the course language
 * @param action – element in the top-right corner, e.g. a small "Add" button (stays clickable above the link)
 * @param tone – 0, 1 or 2; varies the striped cover so neighbouring cards differ
 * @param lang – language of the title (for hyphenation)
 */
export const CourseCard = ({ title, link, linkState, image, meta, badge, action, tone = 0, lang }) => {
    return (
        <article className={styles.base}>
            {image ? (
                <img src={image} alt="" loading="lazy" className={styles.image} />
            ) : (
                <div className={styles.placeholder} data-tone={tone % 3}>
                    <Icon name="course" />
                </div>
            )}
            {badge ? <span className={styles.badge}>{badge}</span> : null}
            {action ? <div className={styles.action}>{action}</div> : null}
            <div className={styles.text}>
                <h2 className={styles.title} lang={lang}>
                    <Link to={link} state={linkState} className={styles.link}>
                        {title}
                    </Link>
                </h2>
                {meta ? <p className={styles.meta}>{meta}</p> : null}
            </div>
        </article>
    );
};
